import { render, staticRenderFns } from "./ClientDetailHeaderCpt.vue?vue&type=template&id=054c77d3&scoped=true&"
import script from "./ClientDetailHeaderCpt.vue?vue&type=script&lang=ts&"
export * from "./ClientDetailHeaderCpt.vue?vue&type=script&lang=ts&"
import style0 from "./ClientDetailHeaderCpt.vue?vue&type=style&index=0&id=054c77d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c77d3",
  null
  
)

export default component.exports